// extracted by mini-css-extract-plugin
export default {"invisibleTab":"mimic___style_invisibleTab__2hkmt"};